<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
<div
  class="flex justify-content-center main-container"
  [class]="{ 'admin-mode': admin, 'full-page': programPubService.getCurrentSubSection()?.backgroundImg }"
  [style]="'background-image:url(' + programPubService.getCurrentSubSection()?.backgroundImg + ')'"
>
  <router-outlet />
</div>
<div [class]="{ 'full-page': programPubService.getCurrentSubSection()?.backgroundImg }" class="footer"></div>
